import { render, staticRenderFns } from "./page5.vue?vue&type=template&id=58494970&scoped=true&"
import script from "./page5.vue?vue&type=script&lang=js&"
export * from "./page5.vue?vue&type=script&lang=js&"
import style0 from "./page5.vue?vue&type=style&index=0&id=58494970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58494970",
  null
  
)

export default component.exports